import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import EventCard from "@/components/EventCard";

const CATEGORIES = ["All", "Singles", "Couples", "Friends", "Special"];

export default function Events() {
  const [sp, setSp] = useSearchParams();
  const active = sp.get("category") || "All";
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const q = active === "All" ? "" : `?category=${active}`;
    api.get(`/events${q}`).then(r => { setEvents(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, [active]);

  const setCategory = (cat) => {
    if (cat === "All") setSp({});
    else setSp({ category: cat });
  };

  return (
    <div className="max-w-7xl mx-auto px-6 py-20" data-testid="events-page">
      <div className="mb-10 max-w-2xl">
        <div className="text-eyebrow">The schedule</div>
        <h1 className="font-heading text-5xl md:text-6xl mt-4">Upcoming events.<br/><em className="italic">Real nights, already planned.</em></h1>
        <p className="text-neutral-600 mt-6 leading-relaxed">Themed parties, game nights, couples date nights, speed dating, holiday socials, and the standout events we plan just for the season — every night hosted by Offline &amp; Available.</p>
      </div>

      <div className="flex flex-wrap gap-2 mb-10" data-testid="category-filter">
        {CATEGORIES.map(cat => (
          <button key={cat} onClick={() => setCategory(cat)} data-testid={`cat-${cat}`}
            className={`px-5 py-2 rounded-full text-sm font-medium transition-all ${active === cat ? "bg-black text-white" : "bg-white border border-neutral-200 text-neutral-700 hover:border-black"}`}>
            {cat}
          </button>
        ))}
      </div>

      {loading ? <div className="text-neutral-500">Loading events…</div> : events.length === 0 ? (
        <div className="card-elegant p-12 text-center text-neutral-600">No events in this category yet. Check back soon or explore other categories.</div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {events.map(e => <EventCard key={e.event_id} event={e} />)}
        </div>
      )}
    </div>
  );
}
